import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { IconContext } from 'react-icons';
import { GrClose } from 'react-icons/gr';
import { Modal } from 'reactstrap';
import { formatCurrency } from '../../utils';

type Props = {
  isOpen: boolean;
  onToggle: () => any;
  price?: string | number;
  commission?: string | number;
  commissionPercentage?: string | number;
  revenue?: string | number;
  currency?: string;
  ratio?: number;
  isConsignment?: boolean;
};

const ModalCommissionInfo = ({
  isOpen,
  onToggle,
  price,
  commission,
  commissionPercentage,
  revenue,
  currency,
  ratio,
  isConsignment,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onToggle}
      modalClassName={'container-modal-commission'}
      contentClassName={'main-content'}
    >
      <div className="commission-content">
        <p className={'title'}>Sales Breakdown</p>
        <div className={'info-container'}>
          <p>{isConsignment ? 'Consignment' : 'Product'} Price</p>
          <p>{formatCurrency(price, ratio, currency)}</p>
        </div>
        <div className={'info-container'}>
          <p>Commission IDR ({commissionPercentage}%)</p>
          <p>
            {revenue !== 0
              ? formatCurrency(commission, ratio, currency)
              : 'Fill the form first'}
          </p>
        </div>
        <div className={'info-container last'}>
          <p className={'bold'}>Total Sales Revenue</p>
          <p className={'bold'}>
            {revenue !== 0
              ? formatCurrency(revenue, ratio, currency)
              : 'Fill the form first'}
          </p>
        </div>
        <div className={'note-container'}>
          <p>
            Note: there is an additional 3% cash out fee from your Seller Credit
            if you withdraw your balance to your bank account.
          </p>
        </div>
      </div>
      <div className={'close-button'} onClick={onToggle}>
        <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
          <div>
            <GrClose />
          </div>
        </IconContext.Provider>
      </div>
    </Modal>
  );
};

export default ModalCommissionInfo;
